// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import iView from 'iview';
import './my-theme/index.less';
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import moment from 'moment'
import store from '@/store/store';
import VueAMap from 'vue-amap';
import { lazyAMapApiLoaderInstance } from 'vue-amap';

import lodash from 'lodash'
import echarts from 'echarts'
Vue.prototype.$echarts=echarts
Vue.use(VueAMap);

Vue.prototype._ = lodash
Vue.config.productionTip = false;

Vue.use(iView);

//防止犯SB问题
Object.defineProperty(Vue.prototype, '$moment', { value: moment });

Vue.filter('format',value=>{
  if(value){
    return moment(value).format('YYYY-MM-DD')
  }
});
Vue.filter('formatWithhour',value=>{
  if(value){
    return moment(value).format('YYYY-MM-DD HH:mm')
  }
});
//金额保留2位小数
Vue.filter('moneyFilter',value => {
  if(value!==undefined && value!==null){
    return `￥${Number(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
  }
});

//图片Url拼接
Vue.filter('imgSrc',value=>{
  if(value){
    return `${process.env.API_URL_BASE}/commons/attachments/download.do?filename=${value}`
  }
});

Vue.filter('imgSrc1',value=>{
  if(value){
    return `${process.env.IMGURL}/fleet/files/${value}`
  }
});

//银行卡号
Vue.filter('cardSlice',value=>{
  if(value){
    return value.slice(-4)
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store:store,
  components: { App },
  template: '<App/>'
});






// WEBPACK FOOTER //
// ./src/main.js